//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data: function data() {
        return {
            loading: true,
            money: {
                decimal: ',',
                thousands: '.',
                prefix: '',
                suffix: '',
                precision: 2,
                masked: false
            },
            file: '',
            invoice: {
                dueDate: moment().add(30, 'days').format("MM/DD/YYYY"),
                invoiceDate: moment().format("MM/DD/YYYY"),
                period: moment(),
                amount: 0.00,
                vendor: null,
                number: null,
                notes: null,
                recurring: false,
                frequency: 'Monthly',
                frequencyDay: moment().format("D"),
                frequencyEnd: 'Never',
                frequencyEndDate: null
            },
            lines: [{
                property: false,
                expense: null,
                cash: null,
                unit: null,
                amount: '0.00',
                description: ''
            }],
            multi: false,
            vendors: [],
            accounts: [],
            properties: [],
            units: [],
            action: 'add',
            invoiceValidations: [{ model: 'invoice.vendor', rules: 'required' }, { model: 'invoice.number', rules: 'required' }]
        };
    },
    created: function created() {
        Event.$on('update-ap-invoice', this.updateAPInvoice);
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('update-ap-invoice');
    },


    methods: {
        handleFileUpload: function handleFileUpload() {
            this.file = this.$refs.file.files[0];
            this.invoice.attachment = true;
        },
        updateAPInvoice: function updateAPInvoice(item) {
            var $el = this;

            Object.assign(this.$data, this.$options.data());
            $el.action = 'update';

            axios.get('/prototype/vendors/all').then(function (response) {
                response.data.map(function (vendor) {
                    return vendor.name = vendor.id + ': ' + vendor.name;
                });
                $el.vendors = response.data;
            });

            axios.post('/prototype/accounting/general-ledger/accounts/fetch').then(function (response) {
                $el.accounts = response.data;
            });

            axios.get('/prototype/accounting/bank-accounts').then(function (response) {
                $el.bankAccounts = response.data;
            });

            axios.get('/prototype/properties/quick/lookup').then(function (response) {
                $el.properties = response.data.properties;
                if (response.data) {
                    axios.get('/prototype/properties/quick/' + response.data.selected.id + '/buildings').then(function (response) {
                        var buildings = response.data;
                        $el.units = [];
                        buildings.map(function (building) {
                            building.units.map(function (unit) {
                                $el.units.push({ id: unit.id, name: building.name + ' - ' + unit.name });
                            });
                        });
                    });
                }
            });

            axios.get('/prototype/accounting/accounts-payable/invoice/' + item.id).then(function (response) {
                $el.invoice = response.data;
                $el.invoice.invoice_date = moment(response.data.invoice_date).format("MM/DD/YYYY");
                $el.invoice.due_date = moment(response.data.due_date).format("MM/DD/YYYY");
                $el.lines = response.data.entries;
                $el.lines.map(function (line) {
                    line.cash['label'] = line.cash.number + ' - ' + line.cash.name;
                    line.account['label'] = line.account.number + ' - ' + line.account.name;
                }), $el.loading = false;
            });

            $el.$children[0].$data.showModal = true;
            this.$initValidator();
        },
        update: function update(status) {
            var _this = this;

            //create the invoice validation rules based on the lines array.
            this.lines.map(function (line, key) {
                var model = 'lines.' + key + '.account.id';
                var model1 = 'lines.' + key + '.cash.id';
                _this.invoiceValidations.push({ model: model, rules: 'required | integer | min:0' }, { model: model1, rules: 'required | integer | min:0' });
            });

            this.validator.setRules(this.invoiceValidations).validate();

            if (this.validator.fails()) {
                return;
            }
            var formData = new FormData();
            formData.append('attachment', this.file);
            formData.append("id", this.invoice.id);
            formData.append("vendor_id", this.invoice.vendor.id);
            formData.append("number", this.invoice.number);
            formData.append("amount", this.invoice.amount);
            formData.append("invoice_date", this.invoice.invoice_date);
            formData.append("due_date", this.invoice.due_date);
            formData.append("period", this.invoice.gl_period_date);
            formData.append("recurring", JSON.stringify(this.invoice.is_recurring));
            formData.append("status", status);
            formData.append("frequency", this.invoice.frequency);
            formData.append("frequency_day", this.invoice.frequency_interval);
            formData.append("frequency_end_date", this.invoice.ends_at);

            formData.append("notes", this.invoice.notes);
            formData.append("_method", "PUT");

            formData.append("lines", JSON.stringify(this.lines));
            axios.post('/prototype/accounting/accounts-payable/invoice/' + this.invoice.id, formData).then(function (response) {
                _this.$snotify.success('The invoice was updated');
                Event.$emit('refresh-ap-invoices');
                Event.$emit('close-full-modal');
            });
        },
        close: function close() {
            Event.$emit('close-full-modal');
        },
        addLine: function addLine() {
            this.lines.push({
                property: false,
                expense: null,
                cash: null,
                unit: null,
                amount: '0.00',
                description: ''
            });
        },
        deleteLine: function deleteLine(idx) {
            this.lines.splice(idx, 1);
        }
    },

    computed: {
        canPostTo: function canPostTo() {
            return this.accounts.filter(function (account) {
                return account.can_post_to == 1;
            });
        },
        accountNames: function accountNames() {
            return this.canPostTo.map(function (account) {
                return { id: account.id, label: account.number + ' - ' + account.name };
            });
        },
        bankAccountNames: function bankAccountNames() {
            return this.bankAccounts.map(function (account) {
                return { id: account.glaccount.id, label: account.glaccount.number + ' - ' + account.glaccount.name };
            });
        },
        totalItems: function totalItems() {
            return Number.parseFloat(this.lines.reduce(function (prev, cur) {
                return prev + cur.amount;
            }, 0)).toFixed(2);
        },
        difference: function difference() {
            return Number.parseFloat(this.invoice.amount - this.totalItems).toFixed(2);
        }
    }

};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/accounting/accounts-payable/invoices/EditInvoice.vue
// module id = Q8M0
// module chunks = 0 1